import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cms-location-role"
export default class extends Controller {
  static targets = [
    "locationIdSelect", 
    "locationTypeSelect", 
    "roleSelect"
  ]

  connect() {
  }

  updateLocationIds(event) {
    const selectedLocationType = this.locationTypeSelectTarget.value;
    const options = this.locationIdSelectTarget.querySelectorAll('option');

    options.forEach(option => {
      option.classList.add('hidden');

      if (selectedLocationType === 'Borough' && option.dataset.type === 'Borough' ||
          selectedLocationType === 'Venue' && option.dataset.type === 'Venue') {
        option.classList.remove('hidden');
      } else if (selectedLocationType === '' && option.label === ' ') { // Show blank option when no type is selected
        option.classList.remove('hidden');
      }
      if (this.roleSelectTarget.selectedOptions[0].dataset.global === 'true') {
        option.classList.add('hidden');
      }
    });

    if (this.roleSelectTarget.selectedOptions[0].dataset.global === 'true') {
      this.locationIdSelectTarget.selectedIndex = -1; 
    }

    if (this.locationTypeSelectTarget.value === 'Borough' && 
        this.locationIdSelectTarget.selectedOptions[0] &&
        this.locationIdSelectTarget.selectedOptions[0].dataset.type !== 'Borough') {
      this.locationIdSelectTarget.selectedIndex = -1;
    }

    if (this.locationTypeSelectTarget.value === 'Venue' && 
        this.locationIdSelectTarget.selectedOptions[0] &&
        this.locationIdSelectTarget.selectedOptions[0].dataset.type !== 'Venue') {
      this.locationIdSelectTarget.selectedIndex = -1;
    }
  }

  updateLocationType(event) {
    const selectedRole = this.roleSelectTarget.selectedOptions[0]
    const options = this.locationTypeSelectTarget.querySelectorAll('option');

    options.forEach(option => {
      option.classList.add('hidden');
      if (selectedRole.dataset.global === 'true') {
        this.locationTypeSelectTarget.selectedIndex = -1;

        if (option.label == ' ') { 
          option.classList.remove('hidden');
        } 
      } else if  
        (
          (selectedRole.dataset.borough=='true' && option.dataset.type=='Borough') ||
          (selectedRole.dataset.venue=='true' && option.dataset.type=='Venue') 
        ) {
        option.classList.remove('hidden');
        } 
      }
    )

    this.updateLocationIds();
  }
}
        
        




